module.exports = __webpack_public_path__ + "static/media/up-icon.badae67f.svg";